import VoletReno from 'assets/img/volet-reno.png';
import VoletTradi from 'assets/img/volet-tradi.png';
import formInputsTypes from 'constants/simulatorData/simulatorConstant';
import ManoeuvreElectrique from 'assets/img/manoeuvre-electrique.png';
import ManoeuvreManuel from 'assets/img/manoeuvre-manuel.png';
import droite from 'assets/img/stock/droite.png';
import gauche from 'assets/img/stock/gauche.png';

const sortie_cable = {
	id: 'MD',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sortie de câble (vue en face)',
	name: 'sortie_cable',
	className: 'col-6',
	classGroup: 'SProduit',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'gauche',
			value: 'gauche',
			label: 'Gauche',
			imageUrl: gauche,
			nextStep: false,
		},
		{
			id: 'droite',
			value: 'droite',
			label: 'Droite',
			imageUrl: droite,
			nextStep: false,
		},
	],
};

const couleur = {
	id: 'VR-TR-TB-CC',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'couleur',
	classGroup: 'Simulateur_color',
	label: 'Couleur',
	defaultValue: 0,
	nextStepData: sortie_cable,
	nextStep: sortie_cable,
	options: [
		{
			id: 6,
			label: 'Blanc Ral 9016',
			color: '#ffffff',
			icon: 'CustomCircle',
			value: 6,
		},
		{
			id: 60,
			label: 'Gris Clair RAL 7035',
			color: '#C5C7C4',
			icon: 'CustomCircle',
			value: 60,
		},
		{
			id: 14,
			label: 'Gris Anthracite RAL 7016',
			color: '#383e42',
			icon: 'CustomCircle',
			value: 14,
		},

		{
			icon: 'CustomCircle',
			id: 8,
			label: 'Gris Métallique RAL 9006',
			color: '#808080',
			icon: 'CustomCircle',
			value: 8,
		},

		{
			id: 16,
			label: 'Ch\u00eane dor\u00e9 038',
			color: '#CD853F',
			icon: 'CustomCircle',
			value: 16,
		},
	],
};
const largeur = {
	id: 'VR-TR-VRC-W',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeur',
	className: 'col-6',
	label: 'Largeur entre murs (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStep: couleur,
	validation: (value) => {
		return value > 0;
	},
};
const hauteur = {
	id: 'VR-TR-VRC-H',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'hauteur',
	className: 'col-6',
	label: 'Hauteur entre murs (mm)',
	defaultValue: 0,
	placeholder: '0',
	nextStep: largeur,
	validation: (value) => {
		return value > 0;
	},
};
const dimensions = {
	id: 'VR-TR-VRC-TM',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'dimensions',
	className: 'col-6',
	label: 'Dimensions',
	nextStepData: false,
	nextStep: false,
	options: [hauteur, largeur],
};

const typeManoeuvre = {
	id: 'VR-TR-VRC-TM',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'typeManoeuvre',
	className: 'col-6',
	label: 'Manouvre',
	nextStepData: false,
	nextStep: hauteur,
	options: [
		{
			id: 'VR-TR-VRC-TM-MNU',
			label: 'Manuel',
			value: 'Manuel',
			imageUrl: ManoeuvreManuel,
		},
		{
			id: 'VR-TR-VRC-TM-ELE',
			label: 'Èlectrique',
			value: 'Èlectrique',
			imageUrl: ManoeuvreElectrique,
		},
	],
};

const voletRoulantData = {
	id: 'VR-TI',
	type: formInputsTypes?.RADIO_INPUT,
	label: "Type d'installation",
	name: 'typeInstallation',
	className: 'col-12',
	classGroup: 'SInstallation',
	nextStep: typeManoeuvre,
	options: [
		{
			id: 'VR-TR',
			label: 'Traditionnel',
			value: 'VR-TR',
			imageUrl: VoletTradi,
			nextStep: false,
		},
		{
			id: 'VR-RN',
			label: 'Réno/Bloc Baie',
			value: 'VR-RN',
			imageUrl: VoletReno,
			nextStep: false,
		},
	],
};

export default voletRoulantData;
